module.exports = __webpack_public_path__ + "img/metriclogo_color.090f94ea.png";